/* eslint-disable react/no-danger */
import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'

import { withTranslation } from '../../i18n'

import SocialIcons from '../SocialIcons'
import { Heading2 } from '../../styles/listsStyles'
import WysiwygContent from '../WysiwygContent'
import MembersBlock from './MembersBlock'
import * as Styled from './styles'

const PodcastItem = ({ t, podcast }) => {
  const { ...socials } = podcast.links

  const [popoverShownId, setPopoverShownId] = useState(null)
  const onMembersClick = useCallback((id) => {
    setPopoverShownId(id === popoverShownId ? null : id)
  }, [popoverShownId])

  return (
    <>
      <Styled.PodcastBase>
        <div className="pictureWrapper">
          <div
            className="picture"
            style={{ backgroundImage: `url(${podcast.image || '/static/images/empty-artist.svg'})` }}
          />
          <img className="cornerImg" src="/static/images/white-corner@2x.png" alt="" />
        </div>

        <Styled.PodcastContent>
          <Styled.PodcastHeader>
            <div className="episodesCount">
              {t('episodes-count')}
              :&nbsp;
              {podcast.count_episodes}
            </div>
            <SocialIcons socials={socials} className="socials" />
          </Styled.PodcastHeader>

          <h2>{podcast.name}</h2>
          <WysiwygContent className="podcastDescription" content={podcast.description} />

          <Styled.Hosts>
            <div className="title">
              {t('hosts')}
              :
            </div>
            {podcast.hosts?.map(host => (
              <Styled.HostItem key={host.id}>
                <img src={host.photo || '/static/images/empty-artist.svg'} alt={host.name} />
                <div className="info">
                  <div className="name">{host.name}</div>
                  <div className="text">{host.description}</div>
                </div>
              </Styled.HostItem>
            )
            )}
          </Styled.Hosts>
        </Styled.PodcastContent>
      </Styled.PodcastBase>
      <Styled.EpisodesSection>
        <h2>{t('episodes')}</h2>
        <div className="episodes">
          {podcast.episodes?.map((ep, ind) => (
            <Styled.EpisodeBase key={ep.id}>
              <div className="episodeMeta">
                {t('episode-num')}
                {podcast.episodes.length - ind}
              </div>
              <Heading2 as="h3">{ep.name}</Heading2>
              <WysiwygContent className="episodeDescription" content={ep.description} />
              <div className="iframeWrapper" dangerouslySetInnerHTML={{ __html: ep.iframe_podcast }} />
              <MembersBlock episode={ep} isShown={ep.id === popoverShownId} toggleBlock={onMembersClick} />
            </Styled.EpisodeBase>
          )
          )}
        </div>
      </Styled.EpisodesSection>
    </>
  )
}

PodcastItem.propTypes = {
  t: PropTypes.func.isRequired,
  podcast: PropTypes.instanceOf(Object).isRequired
}

export default withTranslation(['podcasts', 'common'])(PodcastItem)
